import { render, staticRenderFns } from "./expendDetail.vue?vue&type=template&id=cd87eedc&"
import script from "./expendDetail.vue?vue&type=script&lang=js&"
export * from "./expendDetail.vue?vue&type=script&lang=js&"
import style0 from "./expendDetail.vue?vue&type=style&index=0&id=cd87eedc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports